import { all, takeLatest, call, select, put, delay } from "redux-saga/effects";
import {
  getContractProductsService,
  getAvaliableProductsService,
  getContractInfoService,
  getEventService,
  getStaffAttendenceInfoService,
  getStaffAttendenceTableService,
} from "../../../service/staff-access.service";
import {
  getContractProductsFailure,
  getContractProductsSuccess,
  getAvaliableProductsFailure,
  getAvaliableProductsSuccess,
  getContractInfoSuccess,
  getContractInfoFailure,
  getEventListSuccess,
  getEventListFailure,
  resetSaleInfoSuccess,
  getStaffAttendenceTableInfoFailure,
  getStaffAttendenceTableInfoSuccess,
  getStaffAttendenceInfoSuccess,
  getStaffAttendenceInfoFailure,
} from "./actions";

function* getContractProducts({ payload }) {
  const selectedToken = (state) => state.auth.token;
  try {
    const token = yield select(selectedToken);
    const { contractNumber, systemUserId } = payload;
    const params = {
      token,
      contractNumber,
      systemUserId,
    };

    const response = yield call(getContractProductsService, params);

    const { data } = response;
    yield put(getContractProductsSuccess(data));
  } catch (error) {
    yield put(getContractProductsFailure(error));
  }
}

function* getAvaliableProducts({ payload }) {
  const selectedToken = (state) => state.auth.token;
  try {
    const token = yield select(selectedToken);
    const { eventId, contractNumber } = payload;
    const params = {
      token,
      eventId,
      contractNumber,
    };

    const response = yield call(getAvaliableProductsService, params);

    const { data } = response;
    yield put(getAvaliableProductsSuccess(data));
  } catch (error) {
    yield put(getAvaliableProductsFailure(error));
  }
}

function* getContractInfo({ payload }) {
  const selectedToken = (state) => state.auth.token;
  try {
    const token = yield select(selectedToken);
    const { serviceOpportunityNumber } = payload;
    const params = {
      token,
      serviceOpportunityNumber,
    };

    const response = yield call(getContractInfoService, params);

    const { data } = response;
    yield put(getContractInfoSuccess(data));
  } catch (error) {
    yield put(getContractInfoFailure(error));
  }
}

// Nova saga que retorna Promise para usar com await
function* getContractInfoAsync({ payload, resolve, reject }) {
  const selectedToken = (state) => state.auth.token;
  try {
    const token = yield select(selectedToken);
    const { serviceOpportunityNumber } = payload;
    const params = {
      token,
      serviceOpportunityNumber,
    };

    const response = yield call(getContractInfoService, params);

    const { data } = response;
    yield put(getContractInfoSuccess(data));

    // Resolve a Promise com os dados
    if (resolve) resolve(data);
  } catch (error) {
    yield put(getContractInfoFailure(error));

    // Reject a Promise com o erro
    if (reject) reject(error);
  }
}

function* getEventList() {
  const selectedToken = (state) => state.auth.token;
  try {
    const token = yield select(selectedToken);

    const response = yield call(getEventService, {
      token,
    });

    if (response.status !== 200) throw new Error("Failed to get event list");
    const { data } = response;
    const { output: events } = data;
    const mappedEvents = events
      .filter((e) => e.active)
      .map((event) => {
        return {
          value: Number(event.idNumber),
          label: event.eventEditionName,
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label));

    yield put(
      getEventListSuccess({
        events: mappedEvents,
      })
    );
  } catch (error) {
    yield put(getEventListFailure(error));
  }
}

function* getStaffAttendenceTableInfo({ payload }) {
  const selectedToken = (state) => state.auth.token;
  try {
    const token = yield select(selectedToken);
    const { year, eventId, roleType, page, size, sortBy, sortDirection } =
      payload;
    const response = yield call(getStaffAttendenceTableService, {
      token,
      year,
      eventId,
      roleType,
      page,
      size,
      sortBy,
      sortDirection,
    });

    if (response.status !== 200)
      throw new Error("Failed to get staff table info");

    const { data } = response;

    yield put(
      getStaffAttendenceTableInfoSuccess({
        staffData: data.items,
        pageInfo: data.paginationInfo,
      })
    );
  } catch (error) {
    yield put(getStaffAttendenceTableInfoFailure(error));
  }
}

function* getStaffAttendenceInfo({ payload }) {
  const selectedToken = (state) => state.auth.token;
  try {
    const token = yield select(selectedToken);
    const { year, eventId, roleType } = payload;
    const response = yield call(getStaffAttendenceInfoService, {
      token,
      year,
      eventId,
      roleType,
    });

    if (response.status !== 200)
      throw new Error("Failed to get staff metrics info");

    const { data } = response;
    const {
      totalInteractions,
      averageServiceTime,
      peakTrafficTime,
      topRequests,
      topAttendants,
    } = data;

    yield put(
      getStaffAttendenceInfoSuccess({
        metrics: {
          totalInteractions,
          averageServiceTime,
          peakTrafficTime,
          topRequests,
          topAttendants,
        },
      })
    );
  } catch (error) {
    yield put(getStaffAttendenceInfoFailure(error));
  }
}

function* resetSaleInfo() {
  yield delay(350);
  yield put(resetSaleInfoSuccess());
}

export default all([
  takeLatest("GET_CONTRACT_PRODUCTS", getContractProducts),
  takeLatest("GET_PRODUCTS_TO_CART", getAvaliableProducts),
  takeLatest("GET_CONTRACT_INFO", getContractInfo),
  takeLatest("GET_CONTRACT_INFO_ASYNC", getContractInfoAsync),
  takeLatest("GET_EVENT_LIST_CAEX", getEventList),
  takeLatest("RESET_SALE_INFO", resetSaleInfo),
  takeLatest("GET_STAFF_ATTENDENCE_TABLE", getStaffAttendenceTableInfo),
  takeLatest("GET_STAFF_ATTENDENCE_INFO", getStaffAttendenceInfo),
]);
